import { DrawerProps, DrawerBody, DrawerFooter, DrawerHeader, Text, Drawer } from '@cad-arc';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';
import { useEventSubjectDataState } from './use-event-subject-data-state';
import { IntegratedFormProvider } from '../forms/integrated-form-provider';
import { FrEventSubjectDataForm } from './fr-event-subject-data-form';
import { FormBody } from '../forms/integrated-form-components/form-body';

export function FrEventSubjectDataDrawer(props: { portalProps: DrawerProps['portalProps'] }) {
    const drawerControls = useDrawerControls();
    const { query, form, saveMutation, onSubmit, subjectStopOptions } = useEventSubjectDataState();

    return (
        <Drawer
            size="lg"
            variant="inline"
            isOpen
            onClose={drawerControls.close}
            closeOnOverlayClick={false}
            portalProps={props.portalProps}
        >
            <IntegratedFormProvider
                form={form}
                query={query}
                onSubmit={onSubmit}
                mutation={saveMutation}
            >
                <DrawerHeader>
                    <Text variant="headingLg">Subject Data</Text>
                </DrawerHeader>
                <DrawerBody>
                    <FormBody>
                        <FrEventSubjectDataForm subjectStopOptions={subjectStopOptions} />
                    </FormBody>
                </DrawerBody>
                <DrawerFooter>
                    <FormSaveButton
                        isDisabled={query.isFetching || query.isError || saveMutation.isError}
                        size="lg"
                    >
                        Submit
                    </FormSaveButton>
                </DrawerFooter>
            </IntegratedFormProvider>
        </Drawer>
    );
}

type FrEventSubjectDataDrawerType = typeof FrEventSubjectDataDrawer;

export type { FrEventSubjectDataDrawerType };
